module.exports = __webpack_public_path__ + "img/45_9.0c817faf.png";